import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Box, Button, FormControl, InputLabel, Select, TextField, inputClasses, inputLabelClasses } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import Home from '../home/Home';
import FundRqst_service from '../../Services/FundRqst_service';
import Snackbar from '../Snacbar'
import { getUserId } from '../Utils/Common';
import FileSaver from 'file-saver';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';
import OperationReportService from '../../Services/Reports/OperationReportService';

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        }
    },
});
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item1 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item2 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: 'Times New Roman',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
    },
}));

function UploadRecipetCopy() {
    ///hidden
    const [designHidden, setdesignHidden] = useState(true);
    const [tablehidden, settablehidden] = useState(true);
    const [VendorHidden, SetVendorHidden] = useState(true);
    const [searchbtnhidden, setsearchbtnhidden] = useState(true);
    const [JobHidden, SetJobHidden] = useState(false);

    const [imgUpload, setimgUpload] = useState(false);
    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severit, setseverit] = useState('');
    const [status, setstatus] = useState('')
    const [fundstatusdrp, setfundstatusdrp] = useState([]);
    const [Vendordrp, setVendordrp] = useState([]);
    //setdetails
    const [funddetails, setfunddetails] = useState([])
    const [funddetails2, setfunddetails2] = useState([])
    const [funddetails3, setfunddetails3] = useState([])
    const [funddetails4, setfunddetails4] = useState([])
    const [funddetails5, setfunddetails5] = useState([])
    const [FilteredDetails, setFilteredDetails] = useState([])
    const [FilteredDetails2, setFilteredDetails2] = useState([])
    // const [paymentcopydetails, setpaymentcopydetails] = useState([])


    const [values, setvalues] = useState({
        jobNo: '',
        fundSts: '',
        vendortype: '',
        ///
        cmid: '',
        purpose_pmtid: '',
        purpose_reqpurid: '',

        Reqamt: '',
        Aprvlamt: '',
        FirstLvlamt: '',
        secLvlamt: '',
        allocatedamt: '',
        releaseamt: '',
    })

    // const [paymentId, setPaymentId] = useState('');

    const fundStsonChange = (e) => {
        setvalues({ ...values, fundSts: e.target.value })
        if (e.target.value === 'JOB') {
            setstatus(1)
        } else if (e.target.value === 'VENDOR') {
            setstatus(2)
        } else if (e.target.value === 'MISCELLANEOUS') {
            setstatus(3)
        } else if (e.target.value === 'CLIENT') {
            setstatus(4)
        }

        if (e.target.value === 'JOB') {
            SetVendorHidden(true)
            SetJobHidden(false)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(false)
        }
        else if (e.target.value === 'VENDOR' || e.target.value === 'MISCELLANEOUS' || e.target.value === 'CLIENT') {
            FundRqst_service.getVendorType(e.target.value).then(res => {
                setVendordrp(res.data)
            });
            SetVendorHidden(false)
            SetJobHidden(true)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(true)
        }
        else if (e.target.value === "") {
            SetVendorHidden(true)
            SetJobHidden(false)
            setdesignHidden(true)
            settablehidden(true)
            setsearchbtnhidden(false)
        }
        var consignmentNumber = '';
        if (e.target.value === 'JOB') {
            if (values.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = values.jobNo;
            }
        }
        else if (e.target.value !== 'JOB') {
            if (values.vendortype === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = values.vendortype;
            }
        }
        FundRqst_service.getPaymentDetails_non_job_no_new(consignmentNumber, '9', e.target.value).then(res => { setfunddetails(res.data); setFilteredDetails(res.data) });

        FundRqst_service.getPaymentDetails_Job_no_new(consignmentNumber, '9', e.target.value).then(res => { setfunddetails4(res.data); setFilteredDetails2(res.data) })

    }
    const vendorTypeonChange = (e) => {
        setvalues({ ...values, vendortype: e.target.value })
        FundRqst_service.getPaymentDetails_non_job_no_new(e.target.value, '9', values.fundSts).then(res => { setfunddetails(res.data); setFilteredDetails(res.data) });

        FundRqst_service.getPaymentDetails_Job_no_new(e.target.value, '9', values.fundSts).then(res => { setfunddetails4(res.data); setFilteredDetails2(res.data) });
    }
    //
    const fundstsName = () => {
        if (status === 1) {
            return 'Job No';
        }
        else if (status === 2) {
            return 'VENDOR';
        }
        else if (status === 3) {
            return 'MISCELLANEOUS';
        }
        else if (status === 4) {
            return 'CLIENT';
        }
    }
    ////
    const Jobserachbtn = () => {
        setvalues({
            ...values, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', requestamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedamt: '',
            releaseamt: ''
        });
        setfunddetails2([])
        setfunddetails3([])
        Getpaymentjob_nonjob_no();
    }
    const [selected, setSelected] = useState([]);
    const [selected1, setSelected1] = useState([]);
    /////
    const getnonpurpose = (trns) => {
        setfunddetails5([])
        const selectedIndex = selected.indexOf(trns.consignment_No);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignment_No);
        }
        setSelected(newSelected);
        setfunddetails2([])
        setvalues({ ...values, cmid: trns.consignment_id, purpose_pmtid: '', Reqamt: '', Aprvlamt: '', allocatedamt: '', FirstLvlamt: '', secLvlamt: '', releaseamt: '', })

        setfunddetails3([]);

        // let details = { cmId: trns.cmId, status: '17', requestStatus: values.fundSts }
        FundRqst_service.get_a_payment_details_request_purpose_v1(trns.consignment_id, '17', values.fundSts).then(res => {
            setfunddetails2(res.data);
        });

        // let details2 = { paymentId: trns.cmId, requestStatus: values.fundSts }
        FundRqst_service.get_a_payment_summary_details(trns.consignment_id, values.fundSts,).then(res => {
            setfunddetails5(res.data);
        })
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;
    ///
    const nonverifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.release_amount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.release_amount);
        }
        setSelected1(newSelected);
        getpaymentdetailsAssign(trns.payments_id, trns.request_purpose, 1)
        setfunddetails3([]);

    }
    const isNonReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///
    const verifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.release_amount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.release_amount);
        }
        setSelected1(newSelected);
        getpaymentdetailsAssign(trns.payments_id, trns.request_purpose, 2)

    }
    const isReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///
    const getpurpose = (trns) => {
        setfunddetails5([])
        const selectedIndex = selected.indexOf(trns.consignment_No);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignment_No);
        }
        setSelected(newSelected);
        setfunddetails3([])
        setvalues({ ...values, cmid: trns.consignment_id, purpose_pmtid: '', allocatedamt: '', Aprvlamt: '', FirstLvlamt: '', releaseamt: '', Reqamt: '', secLvlamt: '' })
        setfunddetails2([]);

        FundRqst_service.get_a_payment_details_request_purpose_v1(trns.consignment_id, '18', values.fundSts).then(res => {
            setfunddetails3(res.data);
        });

        FundRqst_service.get_a_payment_summary_details(trns.consignment_id, values.fundSts).then(res => {
            setfunddetails5(res.data);
        })
    }
    const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
    /////
    const getpaymentdetailsAssign = (payid, reqid, val) => {
        // let details = { paymentId: payid }
        FundRqst_service.get_o_ac_payment_estimated(payid).then(res => {
            const data = res.data;
            const details = data.map((trns) => trns);
            setvalues({
                ...values, purpose_pmtid: payid, purpose_reqpurid: reqid, Reqamt: details[0].request_amount, Aprvlamt: details[0].approval_amount, FirstLvlamt: details[0].first_level_amount, secLvlamt: details[0].second_level_amount,
                allocatedamt: details[0].allocated_amount, releaseamt: details[0].release_amount
            })
        }).catch(error => {
            setMessage(error.message);
            setseverit('error');
            setOpen(true);
        })
    }
    /////
    const Getpaymentjob_nonjob_no = () => {
        var consignmentNumber = '';
        if (values.fundSts === 'JOB') {
            if (values.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = values.jobNo;
            }
        }
        else if (values.fundSts !== 'JOB') {
            if (values.vendortype === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = values.vendortype;
            }
        }
        FundRqst_service.getPaymentDetails_non_job_no_new(consignmentNumber, '9', values.fundSts).then(res => { setfunddetails(res.data); setFilteredDetails(res.data) });

        FundRqst_service.getPaymentDetails_Job_no_new(consignmentNumber, '9', values.fundSts).then(res => { setfunddetails4(res.data); setFilteredDetails2(res.data) });

    }
    // Functions...
    ////getfundstatues=======>
    const FundStatusDropdown = async () => {
        FundRqst_service.getFundStatus().then(res => {
            setfundstatusdrp(res.data)
        })
    }
    const handleClose = () => {
        setOpen(false)
    }
    const fundSrch = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fundOnchange(e.target.value) }} />
    }
    const fundOnchange = (searchedVal) => {
        const filteredvalue = funddetails.filter((trns) => {
            return trns.consignment_No.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails(funddetails)
        } else {
            setFilteredDetails(filteredvalue)
        }
    }
    const fundSrch2 = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fund2Onchange(e.target.value) }} />
    }
    const fund2Onchange = (searchedVal) => {
        const filteredvalue = funddetails4.filter((trns) => {
            return trns.consignment_No.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails2(funddetails4)
        } else {
            setFilteredDetails2(filteredvalue)
        }
    }
    useEffect(() => {
        FundStatusDropdown();
    }, []);

    //

    const uploadrqstcopy = () => {
        console.log('onclick in')
        if (values.purpose_pmtid === '' || !values.purpose_pmtid) {

            setMessage("Please Select Request Purpose............");
            setseverit('warning');
            setOpen(true);
            setimgUpload(false);
        }
        else {
            setimgUpload(true);
        }
    }

    const selectimgUpload = (event) => {
        var currentFile; const file = event.target.files[0];
        const imageMimeTypepng = /image\/(png)/i;
        const imageMimeTypejpg = /image\/(jpg)/i;
        const imageMimeTypeJpeg = /image\/(jpeg)/i;
        const imageMimeTypePdf = /(pdf)/i;
        const reader = new FileReader();
        reader.onload = () => {
            console.log('data ' + reader.result)
            currentFile = reader.result;
            var recipetCopyFile = '';
            if (file.type.match(imageMimeTypepng)) {
                recipetCopyFile = currentFile.split("data:image/png;base64,");
            } else if (file.type.match(imageMimeTypejpg)) {
                recipetCopyFile = currentFile.split("data:image/jpeg;base64,");
            }
            else if (file.type.match(imageMimeTypeJpeg)) {
                recipetCopyFile = currentFile.split("data:image/jpeg;base64,");
            }
            else if (file.type.match(imageMimeTypePdf)) {
                recipetCopyFile = currentFile.split("data:pdf;base64,");
            }

            if (reader.readyState === 2) {
                // let currentFile = b64toBlob(event.target.files,{type:'base64;charset=utf-8'})
                // console.log("event.target.files[0] " + JSON.stringify(recipetCopyFile[1]))
                let details = { payments_id: values.purpose_pmtid, ip_payment_receipt_copy: recipetCopyFile[1], user_id: getUserId() }
                FundRqst_service.update_o_ac_payment_receipt_copy(details).then((res) => {
                    const message = res.data.message;
                    if (message.toString() === 'SUCCESS') {
                        setMessage('Inserted Successfully')
                        setseverit('success')
                        setOpen(true)
                    } else {
                        setMessage('Insertion Failed! ' + message.toString())
                        setseverit('warning')
                        setOpen(true)
                    }
                    event.target.files[0] = null;
                    reader.readyState = 2;
                })
            }
        }
        reader.readAsDataURL(event.target.files[0])
    }
    const [saveImgLoad, setSaveImgLoad] = useState(false);
    const downRecipt = () => {
        setSaveImgLoad(true)
        if (values.purpose_pmtid === '' || !values.purpose_pmtid) {
            setMessage("Please Select Audit Purpose............");
            setseverit('warning');
            setOpen(true);
            setSaveImgLoad(false)
        } else {
            FundRqst_service.get_o_ac_payment_receipt_copy(values.purpose_pmtid).then(res => {
                const data = res.data;
                const lastresult = data.map((item) => item);
                // FileSaver.saveAs(`data:image/jpeg;base64,${lastresult[0].ip_payment_receipt_copy}`, values.purpose_pmtid + ".jpeg")
                const filedata = lastresult[0].toString()
                const formates = filedata.split('/9j/4');
                //    console.log('ggg '+JSON.stringify(formates))
                if (formates[0] === '') {
                    FileSaver.saveAs(`data:image/jpg;base64,${lastresult[0].toString()}`, values.purpose_pmtid + ".jpg");
                } else {
                    const Pngformates = filedata.split('iVBORw0KGg');
                    if (Pngformates[0] === '') {
                        FileSaver.saveAs(`data:image/jpg;base64,${lastresult[0].toString()}`, values.purpose_pmtid + ".jpg");
                    } else {
                        FileSaver.saveAs(`data:application/pdf;base64,${lastresult[0].toString()}`, values.purpose_pmtid + ".pdf");
                    }
                }
                setSaveImgLoad(false)
            }).catch(error => {
                setMessage(error.message);
                setseverit('warning');
                setOpen(true);
                setSaveImgLoad(false)
            })

        }
    }
    // const ExcelOnClick = () => {
    //     const accountId = getUserId();
    //     FundRqst_service.getaccountdetailsbyId(accountId).then(res => {
    //         const data = res.data
    //         const detail = data.map((trns) => trns)

    //         if (detail[0] === [] || !detail[0]) {
    //             setMessage('No Record Found');
    //             setseverit('warning')
    //             setOpen(true)
    //         } else {

    //             var tableContent = "", contenall = '';
    //             for (let i = 0; i < detail.length; i++) {
    //                 console.log(JSON.stringify(detail[i]))
    //                 if (detail[i].account_name !== '') {
    //                     tableContent += detail[i].account_name + "!"
    //                 } else {
    //                     tableContent += '  !';
    //                 }
    //                 if (detail[i].job_amount !== '') {
    //                     tableContent += detail[i].job_amount + "!"
    //                 } else {
    //                     tableContent += '  !';
    //                 }
    //                 if (detail[i].vendor_amount !== '') {
    //                     tableContent += detail[i].vendor_amount + "!"
    //                 } else {
    //                     tableContent += '  !';
    //                 }
    //                 if (detail[i].misc_amount !== '') {
    //                     tableContent += detail[i].misc_amount + "#"
    //                 } else {
    //                     tableContent += '  #';
    //                 }

    //             }
    //             contenall = tableContent;
    //             console.log('asd==>' + JSON.stringify(contenall))
    //             let details = {
    //                 headerName: "3,0,ACCOUNT DETAILS REPORT", headerDetails: "",
    //                 tableHeader: "0,3,Sl.No/1,3,Account Name/2,3,Job Amount/3,3,Vendor Amount/4,3,Miscellaneous Amount",
    //                 tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "BillDep", totalNumberOfColumn: 5, tableContent: contenall.substring(0, contenall.length - 1),
    //             }
    //             OperationReportService.AccountExcelwrite(details).then((res) => {
    //                 const filename = res.data.message;
    //                 // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
    //                 window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

    //             })
    //         }
    //     })

    // }(old)
    const ExcelOnClick = () => {
        const accountId = getUserId();
        FundRqst_service.getaccountdetailsbyId(accountId).then(res => {
            FundRqst_service.getaccountdetailbyId(accountId).then(response => {
                const data = res.data
                const detail = data.map((trns) => trns)

                const data2 = response.data
                const details2 = data2.map((trns) => trns)
                if (detail[0] === [] || !detail[0] || details2[0] === [] || !details2[0]) {
                    setMessage('No Record Found');
                    setseverit('warning')
                    setOpen(true)
                } else {
                    var tableContent = "", contenall = '';
                    for (let i = 0; i < detail.length; i++) {
                        // console.log(JSON.stringify(detail[i]))
                        if (detail[i].account_name !== '') {
                            tableContent += detail[i].account_name + "!"
                        } else {
                            tableContent += '  !';
                        }
                        if (detail[i].job_amount !== '') {
                            tableContent += detail[i].job_amount + "!"
                        } else {
                            tableContent += '  !';
                        }
                        if (detail[i].vendor_amount !== '') {
                            tableContent += detail[i].vendor_amount + "!"
                        } else {
                            tableContent += '  !';
                        }
                        if (detail[i].misc_amount !== '') {
                            tableContent += detail[i].misc_amount + "#"
                        } else {
                            tableContent += '  #';
                        }

                    }
                    contenall = tableContent;
                    var tableContent2 = "", contenall2 = '';

                    for (let i = 0; i < details2.length; i++) {
                        if (details2[i].payments_id !== '') {
                            tableContent2 += details2[i].payments_id + "!"
                        } else {
                            tableContent2 += "!"
                        } if (details2[i].fund_request_type !== '') {
                            tableContent2 += details2[i].fund_request_type + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].consignmentIds !== '') {
                            tableContent2 += details2[i].consignmentIds + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].request_purpose !== '') {
                            tableContent2 += details2[i].request_purpose + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].request_amount !== '') {
                            tableContent2 += details2[i].request_amount + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].approval_amount !== '') {
                            tableContent2 += details2[i].approval_amount + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].first_level_amount !== '') {
                            tableContent2 += details2[i].first_level_amount + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].second_level_amount !== '') {
                            tableContent2 += details2[i].second_level_amount + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].allocated_amount !== '') {
                            tableContent2 += details2[i].allocated_amount + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].release_amount !== '') {
                            tableContent2 += details2[i].release_amount + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].release_mode !== '') {
                            tableContent2 += details2[i].release_mode + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].audit_amount !== '') {
                            tableContent2 += details2[i].audit_amount + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].request_date !== '') {
                            tableContent2 += details2[i].request_date + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].approval_date !== '') {
                            tableContent2 += details2[i].approval_date + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].first_level_date !== '') {
                            tableContent2 += details2[i].first_level_date + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].second_level_date !== '') {
                            tableContent2 += details2[i].second_level_date + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].allocated_date !== '') {
                            tableContent2 += details2[i].allocated_date + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].release_date !== '') {
                            tableContent2 += details2[i].release_date + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].audit_date !== '') {
                            tableContent2 += details2[i].audit_date + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].request_remarks !== '') {
                            tableContent2 += details2[i].request_remarks + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].approval_remarks !== '') {
                            tableContent2 += details2[i].approval_remarks + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].first_level_remarks !== '') {
                            tableContent2 += details2[i].first_level_remarks + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].second_level_remarks !== '') {
                            tableContent2 += details2[i].second_level_remarks + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].allocated_remarks !== '') {
                            tableContent2 += details2[i].allocated_remarks + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].release_remarks !== '') {
                            tableContent2 += details2[i].release_remarks + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].audit_remarks !== '') {
                            tableContent2 += details2[i].audit_remarks + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].req_by !== '') {
                            tableContent2 += details2[i].req_by + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].approved_by !== '') {
                            tableContent2 += details2[i].approved_by + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].first_level_by !== '') {
                            tableContent2 += details2[i].first_level_by + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].second_level_by !== '') {
                            tableContent2 += details2[i].second_level_by + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].allocated_by !== '') {
                            tableContent2 += details2[i].allocated_by + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].released_by !== '') {
                            tableContent2 += details2[i].released_by + "!"
                        } else {
                            tableContent2 += "!"
                        }
                        if (details2[i].audit_by !== '') {
                            tableContent2 += details2[i].audit_by + "#"
                        } else {
                            tableContent2 += "  #"
                        }
                    }
                    contenall2 = tableContent2;
                    console.log('excel 2 values===>+' + JSON.stringify(contenall2))
                    let details = {
                        headerName: "3,0,ACCOUNT DETAILS REPORT", headerDetails: "",
                        tableHeader: "0,3,Sl.No/1,3,Account Name/2,3,Job Amount/3,3,Vendor Amount/4,3,Miscellaneous Amount",
                        tableRowStartsFrom: 4, tableColumnStartsFrom: 0, fileCode: "BillDep", totalNumberOfColumn: 5,
                        tableContent: contenall.substring(0, contenall.length - 1),

                        headerName2: "3,0,ACCOUNT DETAILS REPORT", headerDetails2: "",
                        tableHeader2: "0,3,Sl.No/1,3,Payments_id/2,3,Fund Request Type/3,3,consignmentId/4,3,Request Purpose/5,3,Request Amount/6,3,Approval Amount/7,3,Firstlevel Amount/8,3,SecondLevel Amount/9,3,Allocated_amount/10,3,Release Amount/11,3,Release Mode/12,3,Audit Amount/13,3,Request Date/14,3,Approval Date/15,3,First_level_date/16,3,Second_level_date/17,3,Allocated_date/18,3,Release_date/19,3,Audit_date/20,3,Request_remarks/21,3,Approval_remarks/22,3,First_level_remarks/23,3,Second_level_remarks/24,3,Allocated_remarks/25,3,Release_remarks/26,3,Audit_remarks/27,3,Req_by/28,3,Approved_by/29,3,First_level_b/30,3,Second_level_by/31,3,Allocated_by/32,3,Released_by/33,3,Audit_by",
                        tableRowStartsFrom2: 4, tableColumnStartsFrom2: 0, fileCode2: "BillDep", totalNumberOfColumn2: 34,
                        tableContent2: contenall2.substring(0, contenall2.length - 1)
                    }
                    OperationReportService.AccountExcelwrite(details).then((res) => {
                        const filename = res.data.message;
                        // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
                        window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

                    })
                }
            })
        })

    }
    const navigate = useNavigate();
    const BackButton = () => {
        navigate('/fundrels');
    }
    const ForwardButton = () => {
        navigate('/fundaudit');
    }
    return (
        <div>
            <Home />
            <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
            <div style={{ paddingLeft: '80px', transition: '1s', transitionDelay: 'revert-layer' }}>
                <Row>
                    <Col xs={1}><ToggleButton onClick={BackButton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{ textAlign: 'end' }}> <ToggleButton onClick={ForwardButton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Grid2 container>
                    <Box style={{ width: '11.5%' }}>
                        <Item1>
                            {/* <ToggleButton onClick={BackButton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red', marginLeft: '2px' }}>Non Audit Job</lable>
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ textAlign: 'center' }}>`{fundstsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ textAlign: 'center' }}>{fundSrch()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            FilteredDetails.map((trns) => {
                                                const isItemSelected = isSelected(trns.consignment_No);
                                                return (
                                                    <TableRow hover selected={isItemSelected} key={trns.consignment_No} onClick={() => getnonpurpose(trns)}>
                                                        <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.consignment_No}</StyledTableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item1>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red' }}>Non Audit Purpose</lable>
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: 'center', width: '100px' }}>Description</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {funddetails2.map((trns) => {
                                            const isItemSelected = isNonReqItemSelected(trns.release_amount);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.release_amount} onClick={() => nonverifypurpose(trns)}>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.serialnumber}</StyledTableCell>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.request_purpose}</StyledTableCell>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.release_amount}</StyledTableCell>
                                                </TableRow>)
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '37%' }}>
                        <Item>
                            <div style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bold', fontSize: '20px', marginTop: '2%', marginBottom: '2%' }}><center>UPLOAD RECEPIT COPY</center></div>
                            <Csscontrol fullWidth size='small' style={{ width: '35%' }}>
                                <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Fund Status</InputLabel>
                                <Select InputLabelProps={{ shrink: true, }} label="Fund Statusss" id='fundsts' native style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} onChange={fundStsonChange} value={values.fundSts}>
                                    <option value=''></option>
                                    {fundstatusdrp.map(status => (
                                        <option value={status.requestStatus}>{status.requestStatus}</option>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <CssTextField hidden={JobHidden} size='small' style={{ width: '35%', marginLeft: '2%', marginRight: '1%' }} onChange={vendorTypeonChange} value={values.vendortype} label="Job No" variant="outlined"
                                sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} />

                            <Button hidden={searchbtnhidden} style={{ fontFamily: 'Times New Roman' }} size='small' variant="contained" color="primary" onClick={Jobserachbtn}>Search</Button>

                            <Csscontrol hidden={VendorHidden} fullWidth size='small' style={{ width: '35%', marginLeft: '2%' }}>
                                <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Vendor Type</InputLabel>
                                <Select InputLabelProps={{ shrink: true, }} label="Vendor Typeeee" native style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }}>
                                    <option></option>
                                    {Vendordrp.map(trns => (
                                        <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <div hidden={designHidden}>
                                <Row className='mt-4'>
                                    <Col>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>Request Amt :</InputLabel>
                                    </Col>
                                    <Col style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.Reqamt}</Col>
                                    <Col>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>Approval Amt :</InputLabel>
                                    </Col>
                                    <Col style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.Aprvlamt}</Col>

                                </Row>
                                <Row>
                                    <Col xs={3}>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>1stLvlVerifAmt :</InputLabel>
                                    </Col>
                                    <Col xs={3} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.FirstLvlamt}</Col>
                                    <Col xs={3}>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>2ndLvlVerifAmt :</InputLabel>
                                    </Col>
                                    <Col xs={3} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.secLvlamt}</Col>
                                </Row>
                                <Row>
                                    <Col xs={3}><InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>Allocated Amt :</InputLabel></Col>
                                    <Col xs={3} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.allocatedamt}</Col>
                                </Row>
                                <Row className='mt-3'>
                                    <Col>
                                        <label style={{ fontFamily: 'Times New Roman' }} onClick={uploadrqstcopy} className="btn btn-primary p-1 mt-1" >UPLOAD RECEIPT COPY
                                            {imgUpload ? <input type="file" accept='.jpg,.jpeg,.png,.pdf' onChange={selectimgUpload} hidden /> : null}
                                        </label>{' '}
                                        <Button style={{ fontFamily: 'Times New Roman' }} size='small' variant="contained" className='mt-1' color="primary" onClick={downRecipt}>{saveImgLoad ? "Image Loading" : "DOWNLOAD RECEPIT COPY"}</Button>{' '}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col style={{ width: '49%', marginTop: '1%' }}>
                                        <Button style={{ fontFamily: 'Times New Roman' }} size='small' variant="contained" className='mt-1' color="primary" >REFRESH'</Button>{' '}
                                        <Button style={{ fontFamily: 'Times New Roman' }} size='small' variant="contained" className='mt-1' color="primary" onClick={ExcelOnClick}>ACCOUNT FUND DETAILS</Button>{' '}
                                    </Col>
                                </Row>
                            </div>
                        </Item>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red' }}>Audit Purpose</lable>
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: 'center' }} >Description</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {funddetails3.map((trns) => {
                                            const isItemSelected = isReqItemSelected(trns.release_amount);
                                            return (
                                                <TableRow selected={isItemSelected} hover key={trns.release_amount} onClick={() => verifypurpose(trns)}>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.serialnumber}</StyledTableCell>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.request_purpose}</StyledTableCell>
                                                    <StyledTableCell style={{ ftextAlign: 'center', color: 'darkblue' }}>{trns.release_amount}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '11.5%' }}>
                        <Item2>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red', marginRight: '10px' }}>Audit Job</lable>
                            {/* <ToggleButton onClick={ForwardButton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ textAlign: 'center' }}>`{fundstsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ textAlign: 'center' }}>{fundSrch2()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FilteredDetails2.map((trns) => {
                                            const isItemSelected = isReqjobSelected(trns.consignment_No);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.consignment_No} onClick={() => getpurpose(trns)}>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.consignment_No}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item2>
                    </Box>
                </Grid2>
                <Item hidden={tablehidden}>
                    <TableContainer sx={{ maxHeight: 215 }} className='scrollbarPrime'>
                        <Table stickyHeader className='table table-bordered'>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Sl</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Description</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }} >Request_Date</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2nd_ApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedBY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Release_BY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedBY</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {funddetails5.map((trns) => (
                                    <StyledTableRow hover key={trns.reqPurpose}>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.serialnumber}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.request_purpose}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.request_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.request_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.request_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.req_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approval_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approval_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approval_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approved_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.first_level_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.first_level_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.first_level_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.first_level_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.second_level_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.second_level_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.second_level_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.second_level_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocated_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocated_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocated_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocated_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.released_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_by}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Item>
            </div>
        </div>
    )
}

export default UploadRecipetCopy